export var CLASS_DIALOG_MOVING_ATTR_NAME = 'dialog-moving';
export var CLASS_MODAL_INERT_ATTR_NAME = 'inert';
//# sourceMappingURL=attributes.js.map